<template>
  <div class="sop-container">
    <MySearch
      :namePlaceholder="namePlaceholder"
      :KHSOPxbc="KHSOPxbc"
      @searchFn="searchFn"
      @selectTime="selectTime"
      @createSOP="createSOP"
    ></MySearch>
    <tableWrap>
      <template #table>
        <el-table
          size="medium"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          ref="returnVisitSOPTable"
          :height="
            namePlaceholder == '搜索SOP任务名称'
              ? 'calc(100vh - 289px)'
              : 'calc(100vh - 233px)'
          "
          :highlight-current-row="true"
          :data="tableData"
          style="width: 100%;font-size: 13px"
        >
          <el-table-column
            label="序号"
            type="index"
            width="50"
            align="center"
          />
          <el-table-column
            v-for="(item, index) in tableHeader"
            :key="item.id"
            :label="item.label"
            :prop="item.id"
            show-overflow-tooltip
            :min-width="item.minWidth"
            :align="item.align"
          >
            <template slot="header" slot-scope="scope">
              {{ item.label }}
              <el-tooltip
                v-if="item.id == 'empNum'"
                class="item"
                effect="dark"
                content="群发应完成的员工人数，指的是有可触达的客户的员工，可能与选择员工数不一致，因为部分所选员工没有可触达的客户"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div v-if="namePlaceholder == '搜索SOP任务名称'">
                <div
                  v-if="item.id != 'createMessage' && item.id != 'option'"
                  :class="item.id == 'content' ? 'content-col' : ''"
                >
                  {{ scope.row[item.id] }}
                </div>
                <div v-if="item.id == 'createMessage'">
                  <div>
                    {{
                      scope.row.createByName +
                        " | " +
                        getTime(scope.row.createTime)
                    }}
                  </div>
                </div>
                <div v-if="item.id == 'option'">
                  <el-button
                    class="table-button"
                    type="text"
                    size="small"
                    @click.stop="handleDetail(scope.row.sopId, scope.row)"
                    >详情</el-button
                  >
                  <el-button
                    class="table-button"
                    type="text"
                    size="small"
                    v-if="KHSOPcd"
                    @click.stop="
                      handleData(scope.row.sopId, scope.row.sopName, scope.row)
                    "
                    >数据</el-button
                  >
                  <el-button
                    class="table-button"
                    type="text"
                    size="small"
                    v-if="KHSOPxbc && namePlaceholder == '搜索SOP任务名称'"
                    @click.stop="handleDel(scope.row.sopId)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div v-else>
                <div
                  v-if="item.id == 'msgName'"
                  style="display: flex;align-items: center;"
                >
                  <span
                    v-if="scope.row.caller == 1"
                    style="color:#FFF;
                  background-color: #409EFF;font-size: 12px; padding: 2px 5px; border-radius: 4px;margin-right: 2px;"
                    >院内</span
                  >
                  <span v-if="scope.row.status == -1" style="color:#F56C6C"
                    >【处理失败】</span
                  >
                  <span class="ellipsis-one">
                    {{ scope.row[item.id] }}
                  </span>
                </div>

                <div
                  class="image-container"
                  v-else-if="item.id == 'resourceList'"
                >
                  <div
                    class="image-main"
                    v-if="
                      scope.row.resourceList &&
                        scope.row.resourceList.length > 0
                    "
                  >
                    <el-image
                      v-for="(item, index) in scope.row.resourceList"
                      :key="index"
                      class="item-image"
                      :src="item.fileFullUrl"
                      @click="previewTableImage(item.fileFullUrl)"
                      fit="contain"
                      ><div slot="error" class="image-slot">
                        <span style="font-size: 10px;">加载失败</span>
                      </div>
                    </el-image>
                  </div>
                </div>

                <div
                  v-else-if="
                    item.id == 'empNumDone' || item.id == 'empNumNoDone'
                  "
                >
                  <div>
                    {{ scope.row.status == 0 ? scope.row[item.id] : "-" }}
                  </div>
                </div>
                <div v-else-if="item.id == 'createMessage'">
                  <div>
                    {{
                      scope.row.createByName +
                        " | " +
                        getTime(scope.row.createTime)
                    }}
                  </div>
                </div>
                <div v-else-if="item.id == 'option'">
                  <div v-if="scope.row.status == -1">
                    <span class="ellipsis-one"
                      >数据处理失败，请重新创建该群发</span
                    >
                  </div>
                  <div v-else>
                    <el-button
                      class="table-button"
                      type="text"
                      size="small"
                      @click.stop="handleDetail(scope.row.sopId, scope.row)"
                      >详情</el-button
                    >
                    <el-button
                      class="table-button"
                      type="text"
                      size="small"
                      v-if="KHSOPcd"
                      @click.stop="
                        handleData(
                          scope.row.sopId,
                          scope.row.sopName,
                          scope.row,
                        )
                      "
                      >数据</el-button
                    >
                  </div>
                </div>
                <div v-else :class="item.id == 'content' ? 'content-col' : ''">
                  {{ scope.row[item.id] }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #pagination>
        <Pagination
          v-bind:childMsg="pageparm"
          :pageSizes="pageSizes"
          @callBack="callBack"
        ></Pagination>
      </template>
    </tableWrap>
    <!-- 图片预览 -->
    <el-image
      class="my-preview-image-j"
      :src.async="previewUrl"
      ref="myImg"
      :preview-src-list="previewSrcList"
    >
    </el-image>
  </div>
</template>
<script>
import tableWrap from "@/components/tabelWrap.vue";
import MySearch from "@/views/mass/SOP/components/search.vue";
import { timeFormat } from "@/utils/common.js";
export default {
  name: "commonSOP",
  components: {
    tableWrap,
    MySearch,
  },
  props: {
    tableHeader: {
      type: Array,
      default: () => [],
    },
    pageparm: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 20,
        total: 0,
      }),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    namePlaceholder: {
      type: String,
      default: "搜索SOP任务名称",
    },
    // 可新建/编辑/删除
    KHSOPxbc: {
      type: Boolean,
      default: false,
    },
    // 可查看/导出数据
    KHSOPcd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchSelectTime: [],
      // pageparm: {
      //   currentPage: 1,
      //   pageSize: 20,
      //   total: 0,
      // },
      getDataParams: {
        sopName: "",
        startTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 20,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      previewUrl: "", // 当前的图片预览地址
      //  预览图片列表
      previewSrcList: [],
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    selectTime(value) {
      console.log("valuecommon", value);
      this.searchSelectTime = value;
      if (value != null) {
        this.getDataParams.startTime = value[0];
        this.getDataParams.endTime = value[1];
      } else {
        this.getDataParams.startTime = "";
        this.getDataParams.endTime = "";
      }
      this.$emit("reGet", this.getDataParams);
    },
    searchFn(val) {
      this.getDataParams.sopName = val;
      this.$emit("reGet", this.getDataParams);
    },
    createSOP() {
      this.$emit("createSOP");
    },
    callBack(parm) {
      this.getDataParams.pageNum = parm.currentPage;
      this.getDataParams.pageSize = parm.pageSize;
      this.$emit("reGet", this.getDataParams);
    },
    handleDel(sopId) {
      this.$emit("handleDel", sopId);
    },
    handleDetail(sopId, row) {
      this.$emit("handleDetail", sopId, row);
    },
    handleData(sopId, sopName, row) {
      this.$emit("handleData", sopId, sopName, row);
    },
    /** 格式化时间 */
    getTime(time) {
      console.log("time+++", time);
      console.log("timeFormat+++", timeFormat);
      return timeFormat(time, "yyyy-mm-dd hh:MM:ss");
    },
    // 表格中图片预览
    previewTableImage(url) {
      this.previewSrcList = [];
      this.previewUrl = url;
      this.previewSrcList.push(url);
      this.$refs.myImg.showViewer = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.ellipsis-one {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sop-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-col {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // /deep/ .el-table__body-wrapper {
  //   overflow-y: scroll;
  // }
}

// 图片预览
.my-preview-image-j {
  width: 100px;
  height: 100px;
  display: none;

  /deep/ .el-image__inner {
    visibility: hidden !important;
  }
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  .image-main {
    line-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    .item-image {
      height: 50px;
      width: 50px;
      cursor: pointer;
    }
  }
}
</style>
